import {useQuery} from "@tanstack/react-query";

import {citationsService} from "../services";

export function useCitation(citationId: number | undefined | null) {
  const {data, isSuccess, isPending, isError, error} = useQuery({
    queryKey: ["citation", {citationId}],
    queryFn: () => citationsService.getCitation(citationId!),
    enabled: Boolean(citationId),
    retry: false,
  });

  const citation = citationId && isSuccess && data != null ? data : null;

  return {
    citation,
    isSuccess,
    isPending: Boolean(citationId && isPending),
    isError,
    error,
  };
}
